"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_LOQATE_ADDRESS_SELECT = exports.URL_LOQATE_ADDRESS_SEARCH = void 0;
var _querystring = _interopRequireDefault(require("querystring"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// loqate address search
var URL_LOQATE_ADDRESS_SEARCH = exports.URL_LOQATE_ADDRESS_SEARCH = function URL_LOQATE_ADDRESS_SEARCH(params) {
  return "https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws?".concat(_querystring["default"].encode(params));
};
var URL_LOQATE_ADDRESS_SELECT = exports.URL_LOQATE_ADDRESS_SELECT = function URL_LOQATE_ADDRESS_SELECT(params) {
  return "https://api.addressy.com/Capture/Interactive/Retrieve/v1/json3ex.ws?".concat(_querystring["default"].encode(params));
};